import React, { useEffect, useRef, useState } from 'react'
import { CheckCircle2, Circle } from 'lucide-react'
import { LessonStatsService } from '../../../../services/stats/LessonStatsService'
import { loadWorksheet, getCached, saveWorksheet } from '../../../../features/lesson-builder/lib/worksheetProgress'

// Cuối MỖI PHIẾU HỌC TẬP: HS tự đánh giá mức hoàn thành phiếu (Đạt / Chưa đạt).
// Lưu server theo tài khoản; chọn "Đạt" → tính vào tiến độ (onComplete).
interface WorksheetCheckProps {
  title?: string
  lessonId?: string
  itemKey: string
  onComplete?: () => void
}

const WorksheetCheck: React.FC<WorksheetCheckProps> = ({ title, lessonId, itemKey, onComplete }) => {
  const lid = lessonId || LessonStatsService.getCurrentLessonId() || undefined   // fallback: bài đang xem
  const [value, setValue] = useState<'dat' | 'chua' | ''>('')
  const firedRef = useRef(false)

  useEffect(() => {
    let alive = true
    loadWorksheet(lid).then(() => {
      if (!alive) return
      const saved = getCached(lid, itemKey)?.self_assess
      if (saved === 'dat' || saved === 'chua') {
        setValue(saved)
        if (saved === 'dat' && !firedRef.current) { firedRef.current = true; onComplete?.() }
      }
    })
    return () => { alive = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lid, itemKey])

  const pick = (v: 'dat' | 'chua') => {
    setValue(v)
    saveWorksheet(lid, itemKey, { self_assess: v }, 0)   // lưu ngay
    if (v === 'dat' && !firedRef.current) { firedRef.current = true; onComplete?.() }
  }

  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50/70 p-3 my-2">
      <div className="text-sm font-bold text-emerald-900 mb-2">
        🎯 Tự đánh giá {title ? `— ${title}` : 'phiếu học tập'}: em đã đạt mục tiêu chưa?
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={() => pick('dat')}
          className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-bold border transition ${
            value === 'dat' ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-emerald-700 border-emerald-300 hover:bg-emerald-100'}`}>
          {value === 'dat' ? <CheckCircle2 size={16} /> : <Circle size={16} />} Đạt
        </button>
        <button type="button" onClick={() => pick('chua')}
          className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-bold border transition ${
            value === 'chua' ? 'bg-amber-500 text-white border-amber-500' : 'bg-white text-amber-700 border-amber-300 hover:bg-amber-100'}`}>
          {value === 'chua' ? <CheckCircle2 size={16} /> : <Circle size={16} />} Chưa đạt
        </button>
        {value === 'chua' && <span className="text-xs text-amber-700">Hãy xem lại phiếu & thử các câu hỏi lần nữa nhé.</span>}
        {value === 'dat' && <span className="text-xs text-emerald-700">Tốt lắm! Em có thể sang phiếu tiếp theo.</span>}
      </div>
    </div>
  )
}

export default WorksheetCheck
